import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { FontAwesomeIcon } from '@design-system/font-awesome-icon';
import { useTheme } from '@design-system/theme';
import { PILL_STATUS_PROPS } from '../constants';
export const PillIcon = ({ iconName, iconType, status, }) => {
    const theme = useTheme();
    const iconColor = status
        ? theme.colors[PILL_STATUS_PROPS[status].iconColor]
        : undefined;
    return (_jsx(Box, { mr: "6px", style: { color: 'inherit' }, children: _jsx(FontAwesomeIcon, { color: iconColor, height: "12px", iconName: iconName, iconType: iconType }) }));
};
//# sourceMappingURL=PillIcon.js.map